const shippingData = {
    title: "Shipping Policy",
    updatedDate: "April 1, 2025",
    introduction: [
        "MINDSCLIK through its platform MPERITO provides ability for its customers to launch their branded ecommerce application on web and mobile. As part of the solution few of its customers (businesses) can leverage MINDSCLIK payment gateway to collect money on the purchases made end customer.",
        "The following Shipping Policy is applicable to the Customers or Businesses that are leveraging the MPERITO platform along with its payment gateway:"
    ],
    sections: [
        {
            title: "Shipping Process",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Orders will be processed and shipped within 2-3 business days from the date of purchase.",
                        "Shipping times may vary depending on the destination and shipping method selected by the customer.",
                        "Customers will receive a tracking number from the businesses via email once the order has been shipped.",
                        "Order delivery status can be tracked by customer by login into the application and view the order history / details"
                    ]
                },

            ]
        },
        {
            title: "Shipping Rates",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Shipping rates will be calculated based on the weight of the package and the destination address.",
                        "Customers will have the option to choose from various shipping methods at checkout, each with its associated cost."
                    ]
                },

            ]
        },
        {
            title: "International Shipping",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "We offer international shipping to select countries. International customers are responsible for any customs duties, taxes, or fees incurred during importation.",                        
                    ]
                },

            ]
        },
        {
            title: "Shipping Address",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Customers are responsible for providing accurate shipping addresses. MINDSCLIK and MPERITO are not liable for any delays or non-delivery due to incorrect address information provided by the customer.",
                    ]
                },

            ]
        },
        {
            title: "Delivery Issues",
            subtitle: "",
            content: [
              
                {
                    type: "bullet",
                    items: [
                        "In the event of a delivery issue such as non-delivery or damaged goods, customers are advised to contact our customer support team for assistance."
                    ]
                },
            ]
        },
 
        {
            title: "Changes to this Shipping Policy",
            subtitle: "",
            content: [
                {
                    type: "text",
                    items: [
                        "We may update Our Shipping Policy from time to time. We will notify You of any changes by posting the new Shipping Policy on this page.",
                        'We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Shipping Policy.',
                        'You are advised to review this Shipping Policy periodically for any changes. Changes to this Shipping Policy are effective when they are posted on this page.'
                    ]
                },
            ]
        },
        {
            title: "Contact Us",
            subtitle: "",
            content: [
                {
                    type: "text",
                    items: [
                        "If you have any questions about this Shipping Policy, You can contact us:",
                    ]
                },
                {
                    type: "bullet",
                    items: [
                        "By email: support@mindsclik.com",
                    ]
                },

            ]
        },
    ]
};

export default shippingData;

// type = { title | text | bullet | numbered }